import { render, staticRenderFns } from "./SubcheoBanner.vue?vue&type=template&id=e56a1eae&scoped=true"
import script from "./SubcheoBanner.vue?vue&type=script&lang=js"
export * from "./SubcheoBanner.vue?vue&type=script&lang=js"
import style0 from "./SubcheoBanner.vue?vue&type=style&index=0&id=e56a1eae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56a1eae",
  null
  
)

export default component.exports